import { useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { ICalculation } from "../../../models/calculation";
import { ivaSelectionOptions, ivaEquationOptions } from "../../../store/ccValidationReducer";
import { verticesSelectionOptions } from "../../../store/verticesReducer";

const formatVertexSelection = (opt: number) => {
    if (opt === -1) return "Manual mode";
    else return verticesSelectionOptions.filter(x => x.key === opt)[0].text;
};

const formatIvaSelection = (opt: number) => {
    return ivaSelectionOptions.filter(x => x.key === opt)[0].text;
};

const formatIvaEquation = (opt: number) => {
    return ivaEquationOptions.filter(x => x.key === opt)[0].text;
};

const formatBoolean = (opt: boolean) => {
    if (opt) {
        return "Yes";
    }
    else {
        return "No"
    };
};

interface IProps {
    calculation: ICalculation;
}

export const CalcPropsVertices = ({ calculation }: IProps) => {
    const [open, setOpen] = useState(false);

    function arrayVerticeConverter(verticeForManual: number[] | number) {
        return Array.isArray(verticeForManual) ? verticeForManual.flat().join(", ") : verticeForManual
    }

    return (
        <Accordion id="accordion-CalcPropsVertices-a">
            <Accordion.Title id="accordionTitle-CalcPropsVertices-a" active={open} index={0} onClick={() => setOpen(!open)}>
                <Icon id="icon-CalcPropsVertices-a" name="dropdown" />
                Vertices
            </Accordion.Title>
            <Accordion.Content id="accordionContent-CalcPropsVertices-a" active={open}>
                {calculation.vertexSelection === -1
                    ? Object.entries(calculation.vertices!).map((v, index) => (
                        <p id={`p-CalcPropsVertices-a-${index}`} key={v[0]}>
                              <label id={`label-CalcPropsVertices-a-${index}`}>
                                {//v[0].padStart(2, "0") + ":30"
                                    calculation.activeTimestamps?.find((element) => element.key === Number(v[0]))?.text
                                }
                                  :&nbsp;
                              </label>
                              {arrayVerticeConverter([v[1][index]])}
                          </p>
                      ))
                    : Object.entries(calculation.vertices!).map((v, index2) => (
                          <p id={`p-CalcPropsVertices-b-${index2}`} key={v[0]}>
                              <label id={`label-CalcPropsVertices-b-${index2}`}>
                                {//v[0].padStart(2, "0") + ":30"
                                    calculation.activeTimestamps?.find((element) => element.key === Number(v[0]))?.text
                                }
                                  :&nbsp;
                              </label>
                              {formatVertexSelection(calculation.vertexSelection)}
                          </p>
                      ))}
                <p id="p-CalcPropsVertices-c">
                    <label id="label-CalcPropsVertices-d">Iva selection:&nbsp;</label>
                    {formatIvaSelection(calculation.ccValidation!.ivaSelection)}
                </p>
                <p id="icon-CalcPropsVertices-e">
                    <label id="label-CalcPropsVertices-e">Iva equation:&nbsp;</label>
                    {formatIvaEquation(calculation.ccValidation!.ivaEquation)}
                </p>
                <p id="icon-CalcPropsVertices-f">
                    <label id="label-CalcPropsVertices-e">Vertex distance by loads scaling:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.scaleByLoad)}
                </p>
                <p id="icon-CalcPropsVertices-g">
                    <label id="label-CalcPropsVertices-e">Vertex distance weighting factors:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.weightDistance)}
                </p>
            </Accordion.Content>
        </Accordion>
    );
};
